/*
 * @Description:
 * @Author: kai.zhou
 * @Date: 2020-03-09 16:30:27
 * @LastEditors: kai.zhou
 * @LastEditTime: 2020-08-25 16:17:02
 */

import React from "react";
import { HashRouter as Router } from "react-router-dom";
import { renderRoutes } from "assets/renderRouter";
import Loadable from "react-loadable"; //按需加载路由插件
import { Provider } from "react-redux";
import { store } from "../tools/store";

const MyLoadingComponent = (v: { isLoading: any; error: any }) => {
  if (v.isLoading) {
    return <div>Loading...</div>;
  } else if (v.error) {
    return <div>Sorry, there was a problem loading the page.</div>;
  } else {
    return null;
  }
};
const GoodDetail = Loadable({
  loader: () => import("../views/goodDetail"),
  loading: MyLoadingComponent,
});
const Activity = Loadable({
  loader: () => import("../views/activity"),
  loading: MyLoadingComponent,
});
const routes = [
  {
    path: "/goodDetail", //新首页
    component: GoodDetail,
  },
  {
    path: "/activity", //新首页
    component: Activity,
  },
  {
    path: "/",
    redirect: "/goodDetail",
  },
];

const mRoute = () => {
  return (
    <Provider store={store}>
      <Router>{renderRoutes(routes)}</Router>
    </Provider>
  );
};

export default mRoute;
